import { render } from "./boleta.vue?vue&type=template&id=74299ed4"
import script from "./boleta.vue?vue&type=script&lang=js"
export * from "./boleta.vue?vue&type=script&lang=js"

import "./boleta.vue?vue&type=style&index=0&id=74299ed4&lang=css"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__